import type { EnvironmentStopResult } from "@/lib/api";
import { useToastStore } from "@/stores/useToastStore";

/** 停止・再起動の要求で backend が返した停止フックの結果を知らせる。 */
export function showEnvironmentStopNotice(result: EnvironmentStopResult | undefined): void {
	if (!result?.notice) return;
	useToastStore.getState().show({
		type: result.hookStatus === "succeeded" && result.stopConfirmed ? "info" : "error",
		message: result.notice,
	});
}
